import { createStore, applyMiddleware, compose } from "redux"
import rootReducer from "../reducers"
import thunk from "redux-thunk"
import { ValidateStore } from "./validationMiddleware"
import Http from "../services/http"
import { routerMiddleware } from "connected-react-router"
import { createHashHistory } from "history"
const camelcaseKeys = require("camelcase-keys-deep")

const middleware = routerMiddleware(createHashHistory())

const composeEnhancers = (
    process.env.ENV === "DEV" &&
    window && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
) || compose

function configureStore(initialState?: any) {
    const enhancer = composeEnhancers(
        applyMiddleware(thunk, ValidateStore, middleware)
    )
    // create store
    return createStore(
        rootReducer,
        initialState!,
        enhancer,
    )
}

const initState: any = (window as any).initState

const store = configureStore(camelcaseKeys(initState))

Http.dispatch = store.dispatch

store.dispatch({ type: "ForceValidation", payload: "" })

// export store singleton instance
export default store